import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=00d67a9e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=00d67a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d67a9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00d67a9e')) {
      api.createRecord('00d67a9e', component.options)
    } else {
      api.reload('00d67a9e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=00d67a9e&scoped=true&", function () {
      api.rerender('00d67a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VtYdbUfLaRQf/JS/comp/DocBox.vue"
export default component.exports